export const SetInvoicesFile = (invoicesFile) => {
    return {
        type: 'LIST_INVOICES_FILE',
        invoicesFile,
    };
};

export const setInvoiceFile = (invoiceFile) => {
    return {
        type: 'SET_INVOICE_FILE',
        invoiceFile,
    };
};

export const listMission = (missionList) => {
    return {
        type: 'LIST_MISSION',
        missionList,
    };
};

export const setSuppliers = (suppliers) => {
    return {
        type: 'PICKING_SUPPLIERS',
        suppliers,
    };
};

export const setParts = (parts) => {
    return {
        type: 'PICKING_PARTS',
        parts,
    };
};

export const setRoutes = (routes) => {
    return {
        type: 'PICKING_ROUTES',
        routes,
    };
};

export const setRouteItem = (route) => {
    return {
        type: 'SET_ROUTE',
        route,
    };
};

export const setRouteUsers = (routeUsers) => {
    return {
        type: 'PICKING_ROUTE_USERS',
        routeUsers,
    };
};

export const setRouteUser = (routeUser) => {
    return {
        type: 'SET_ROUTE_USER',
        routeUser,
    };
};

export const setOrders = (orders) => {
    return {
        type: 'PICKING_ORDERS',
        orders,
    };
};

export const setFilter = (filter) => {
    return {
        type: 'PICKING_FILTER',
        filter,
    };
};

export const resetFilter = () => {
    return {
        type: 'RESET_PICKING_FILTER',
    };
};


export const selectOrder = (order) => {
    return {
        type: 'PICKING_SELECT_ORDER',
        order,
    };
};

export const selectMission = (mission) => {
    return {
        type: 'PICKING_SELECT_MISSION',
        mission,
    };
};

export const updateMissionStatus = (orderItemId, status) => {
    return {
        type: 'UPDATE_MISSION_STATUS',
        orderItemId,
        status
    };
};

export const updateOrderStatus = (orderId, status) => {
    return {
        type: 'UPDATE_ORDER_STATUS',
        orderId,
        status
    };
};
// TODO: Esta action não está implementada no reducer
export const addOrderItem = (orderItem) => {
    return {
        type: 'PICKING_ADD_ORDER_ITEM',
        orderItem
    };
};
// TODO: Esta action não está implementada no reducer
export const updateOrderItem = (orderItem) => {
    return {
        type: 'PICKING_UPDATE_ORDER_ITEM',
        orderItem
    };
};

export const resetOrder = () => {
    return {
        type: 'RESET_ORDER'
    };
};

export const resetOrders = () => {
    return {
        type: 'RESET_ORDERS'
    };
};

export const updateOrder = (order) => {
    return {
        type: 'PICKING_UPDATE_ORDER',
        order
    };
};

export const unblockOrder = (orderId) => {
    return {
        type: 'PICKING_UNBLOCK_ORDER',
        orderId
    };
};

export const removeOrder = (orderId) => {
    return {
        type: 'PICKING_REMOVE_ORDER',
        orderId
    };
};

export const unblockOrderItem = (orderId, orderItemId) => {
    return {
        type: 'PICKING_UNBLOCK_ORDER_ITEM',
        orderId,
        orderItemId
    };
};

export const changeUserOrder = (orderId, newUser) => {
    return {
        type: 'PICKING_CHANGEUSER_ORDER',
        orderId,
        newUser
    };
};

export const setRouteAlert = (routeId, typeAlertId) => {
    return {
        type: 'SET_ROUTE_ALERT',
        routeId,
        typeAlertId
    }
};

export const updateLogs = (logs) => {
    return {
        type: 'UPDATE_LOGS',
        logs
    }
}

export const updateCimFile = (cimFile) => {
    return {
        type: 'SET_CIM_FILE',
        cimFile
    }
}

export const selectCimFileItem = (cimFileItem) => {
    return {
        type: 'SELECT_CIM_FILE_ITEM',
        cimFileItem
    }
}